import { useMemo } from 'react'
import {
  AttachMoney,
  CreditCard,
  Group,
  HomeOutlined,
  Menu,
  ReceiptOutlined,
  RequestQuote,
  ShieldOutlined,
  Share,
  SwapVert,
  Widgets,
} from '@mui/icons-material'
import { Badge } from '@mui/material'
import { CurrentPlanCard } from '@/components/current-plan-card'
import { useCompany } from '@/context/companies'
import { isNewFeature, readViewAsUserKey } from '@/helpers'
import { routes } from '@/router'
import { UserProfile } from '@/types'
import { NavigationConfig } from './types'

export function useAccountingNavigation(): NavigationConfig {
  const { deal } = useCompany()
  const isInsuranceNew = isNewFeature('insurance')

  const isAdmin = useMemo(() => {
    const user = JSON.parse(
      localStorage.getItem('user-profile') || '{}',
    ) as UserProfile

    return (
      deal.deal_users.find((dealUser) => dealUser.profile === 'admin')
        ?.user_key === (readViewAsUserKey() ?? user.key)
    )
  }, [deal])

  const items = useMemo(
    () => [
      {
        name: 'Home',
        route: routes.accounting.index,
        icon: <HomeOutlined />,
      },
      {
        name: 'Faturamento',
        route: routes.accounting.revenue,
        icon: <AttachMoney />,
      },
      {
        name: 'Notas Fiscais',
        route: routes.accounting.fiscalNotes.index,
        icon: <ReceiptOutlined />,
      },
      {
        name: 'Movimento mensal',
        route: routes.accounting.monthlyDocuments,
        icon: <SwapVert />,
      },
      {
        name: 'Guias de Impostos',
        route: routes.accounting.taxes,
        icon: <RequestQuote />,
      },
      {
        name: 'Sócios',
        route: routes.accounting.partners.index,
        icon: <Group />,
        hide: !isAdmin,
      },
      {
        name: 'Colaboradores',
        route: routes.accounting.collaborators,
        icon: <Group />,
        hide: !isAdmin,
      },
      {
        name: 'Serviços adicionais',
        route: routes.accounting.additionalServices,
        icon: <Widgets />,
      },
      {
        name: 'Seguros',
        route: routes.accounting.insurance,
        icon: <ShieldOutlined />,
        isNew: isInsuranceNew,
      },
      {
        name: 'Mensalidades',
        route: routes.accounting.billing,
        icon: <CreditCard />,
      },
      {
        name: 'Indique e Ganhe',
        route: routes.accounting.referAndEarn,
        icon: <Share />,
      },
    ],
    [isAdmin, isInsuranceNew],
  )

  const mobileItems = useMemo(
    () => [
      {
        route: routes.accounting.index,
        icon: <HomeOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.accounting.revenue,
        icon: <AttachMoney sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.accounting.fiscalNotes.index,
        icon: <ReceiptOutlined sx={{ fontSize: 28 }} />,
      },
      {
        route: routes.accounting.menu,
        icon: (
          <Badge color="secondary" variant="dot" invisible={!isInsuranceNew}>
            <Menu sx={{ fontSize: 28 }} />
          </Badge>
        ),
      },
    ],
    [isInsuranceNew],
  )

  return {
    items,
    menuItems: items.filter((item) => item.route !== routes.accounting.index),
    mobileItems,
    sidebarCard: <CurrentPlanCard />,
  }
}
